import {html} from 'lit';
import {selectSpcIsSatisfied} from '../selectors';

export const lineColumnBollard = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		features: [
			'shared::Context::CX_Region',
			'shared::Context::CX_Usage',
			'shared::ProductType::HS_HousingType',
		],
		widgets: []
	},
	{
		id: 'lightdistribution',
		label: {
			de: 'Beleuchtungsart',
			en: 'Illumination Style',
			fr: 'Style d\'Éclairage',
		},
		visual: 'lightdistribution',
		features: [
			'shared::PoleSpecialLine::HS_Construction',
		]
	},
	{
		id: 'lightengine',
		label: {
			de: 'Optik',
			en: 'Optics',
			fr: 'Optique',
		},
		visual: 'optics',
		features: [
			'shared::Context::LU_Filter_LightEmission_Uplight',
			'shared::Context::LU_Filter_LightEmission_CA',
			//'root::LightEngine_1::LE_LightEmission_Uplight',
			//'root::LightEngine_1::LE_LightEmission_CA',

			//'shared::Context::HS_LightEmission',
			//'shared::Context::HS_LightEmissionCAFilter',
			//'root::LightEngine_1::LE_UpLight',

			'root::LightEngine_1::LE_LightDistribution',
			'root::LightEngine_1::LE_ColourTemperature',
			'root::LightEngine_1::LE_ReflectorColour',
			'root::LightEngine_1::LE_OpticalVersion',
			'root::LightEngine_1::LE_LightEngineModuleSize',
			'root::LightEngine_2::LE_LightEngineModuleSize',


			//'root::LightEngine_1::LE_DimmingLevel',
			//'root::LightEngine_1::LE_LuminousFlux',
			//'root::LightEngine_2::LE_ColourTemperature',
			//'root::LightEngine_2::LE_LightDistribution',
			//'root::LightEngine_2::LE_LuminousFlux',
			//'root::LightEngine_2::LE_OpticalVersion',
			//'root::LightEngine_2::LE_ReflectorColour',
			//'shared::PoleSpecialLine::HS_HousingMountingLocationEblock_2'
		],
		widgetsEnd_Debug: [
			html`<vertical-slider
				.title=${{de: 'Dimmstufe', en: 'Dimm Level', fr: 'Niveau de gradation'}}
				.isSatisfied= ${selectSpcIsSatisfied}
				action='decisions/setDimmLevel'
			></vertical-slider>`,
		]
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		features: [
			'shared::PoleBasic::HS_Height',
			'shared::ColourCoating::HS_HousingColour',
			'shared::ColourCoating::HS_HousingCoating',
			'shared::PoleBasic::HS_Base',
			'shared::PoleBasic::HS_NumberPoleDoors',
			'shared::PoleSpecialLine::HS_HousingMountingLocationEBlock_1',
			'shared::PoleSpecialLine::HS_HousingMountingLocationEblock_2',
			//'root::EBlock_1::EB_EBlockMountingType',
			//'root::EBlock_2::EB_EBlockMountingType',
			//'shared::HousingLuminaire::HS_HousingShape',
			//'shared::HousingLuminaire::HS_HousingHeight',
		]
	},
	{
		id: 'electricblock',
		label: {
			de: 'Steuerung',
			en: 'Control',
			fr: 'Contrôle',
		},
		visual: 'housing',
		features: [
			'root::EBlock_1::EB_Control',
			//'root::EBlock_1::EB_ControlNoWire',
			//'root::EBlock_1::EB_ControlWire',
			'root::EBlock_1::EB_ElectricalProtectionClass',
			'shared::Zhaga::HS_HousingZhaga',
			'root::EBlock_1::EB_ConstantLumenTechnology',
			//'root::EBlock_2::EB_Control',
			//'root::EBlock_2::EB_ControlNoWire',
			//'root::EBlock_2::EB_ControlWire',
			//'root::EBlock_2::EB_ElectricalProtectionClass',
			//'root::EBlock_2::EB_ConstantLumenTechnology',
		]
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];
export const lineColumnIntern = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		features: [
			'shared::Context::CX_Region',
			'shared::Context::CX_Usage',
			'shared::ProductType::HS_HousingType',
			//'root::CX_Region',
			'shared::PoleSpecialLine::HS_Construction',

			'shared::Context::LU_Filter_LightEmission_Uplight',
			'shared::Context::LU_Filter_LightEmission_CA',
			//'root::LightEngine_1::LE_LightEmission_Uplight',
			//'root::LightEngine_1::LE_LightEmission_CA',
			//'root::LightEngine_2::LE_LightEmission_Uplight',
			//'root::LightEngine_2::LE_LightEmission_CA',
		],
		widgets: []
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		features: [
			'shared::PoleBasic::HS_Base',
			'shared::PoleBasic::HS_Height',
			'shared::ColourCoating::HS_HousingCoating',
			'shared::ColourCoating::HS_HousingColour',
			//'shared::HousingLuminaire::HS_HousingShape',
			//'shared::HousingLuminaire::HS_HousingHeight',
			'shared::PoleBasic::HS_NumberPoleDoors',
			'root::HS_HousingPowerConnection',
			'root::HS_HousingPowerConnectionPosition',
			'root::HS_HousingMountingLocationEblock_1',
			'root::HS_HousingMountingLocationEblock_2',
		]
	},
	{
		id: 'lightengineA',
		label: {
			de: 'Optik A',
			en: 'Optics A',
			fr: 'Optique A',
		},
		visual: 'housing',
		features: [
			'root::LightEngine_1::LE_ColourTemperature',
			//'root::LightEngine_1::LE_DimmingLevel',
			'root::LightEngine_1::LE_LightDistribution',
			'root::LightEngine_1::LE_LuminousFlux',
			'root::LightEngine_1::LE_LightEngineModuleSize',
			'root::LightEngine_1::LE_OpticalVersion',
			'root::LightEngine_1::LE_ReflectorColour',
		]
	},
	{
		id: 'lightengineB',
		label: {
			de: 'Optik B',
			en: 'Optics B',
			fr: 'Optique B',
		},
		visual: 'housing',
		features: [
			'root::LightEngine_2::LE_ColourTemperature',
			//'root::LightEngine_2::LE_DimmingLevel',
			'root::LightEngine_2::LE_LightDistribution',
			'root::LightEngine_2::LE_LuminousFlux',
			'root::LightEngine_2::LE_LightEngineModuleSize',
			'root::LightEngine_2::LE_OpticalVersion',
			'root::LightEngine_2::LE_ReflectorColour',
		]
	},
	{
		id: 'electricA',
		label: {
			de: 'EBlock A',
			en: 'EBlock A',
			fr: 'EBlock A',
		},
		visual: 'housing',
		features: [
			'root::EBlock_1::EB_ConstantLumenTechnology',
			'root::EBlock_1::EB_Control',
			'root::EBlock_1::EB_EBlockMountingType',
			'root::EBlock_1::EB_ElectricalProtectionClass',
			'root::EBlock_1::EB_Wattage',
			'shared::Zhaga::HS_HousingZhaga'
		]
	},
	{
		id: 'electricB',
		label: {
			de: 'EBlock B',
			en: 'EBlock B',
			fr: 'EBlock B',
		},
		visual: 'housing',
		features: [
			'root::EBlock_2::EB_ConstantLumenTechnology',
			'root::EBlock_2::EB_Control',
			'root::EBlock_2::EB_EBlockMountingType',
			'root::EBlock_2::EB_ElectricalProtectionClass',
			'root::EBlock_2::EB_Wattage',
		], // null
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];
export const lineBollardIntern = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		features: [
			'shared::Context::CX_Region',
			'shared::Context::CX_Usage',
			'shared::ProductType::HS_HousingType',
			'shared::PoleSpecialLine::HS_Construction',

			'shared::Context::LU_Filter_LightEmission_Uplight',
			'shared::Context::LU_Filter_LightEmission_CA',
			//'root::LightEngine_1::LE_LightEmission_Uplight',
			//'root::LightEngine_1::LE_LightEmission_CA',
			//'root::LightEngine_2::LE_LightEmission_Uplight',
			//'root::LightEngine_2::LE_LightEmission_CA',
		],
		widgets: []
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		features: [
			'shared::PoleBasic::HS_Base',
			'shared::PoleBasic::HS_Height',
			'shared::ColourCoating::HS_HousingCoating',
			'shared::ColourCoating::HS_HousingColour',
			//'shared::HousingLuminaire::HS_HousingShape',
			//'shared::HousingLuminaire::HS_HousingHeight',
			'shared::PoleBasic::HS_NumberPoleDoors',
			'root::HS_HousingPowerConnection',
			'root::HS_HousingPowerConnectionPosition',
			'root::HS_HousingMountingLocationEblock_1',
			'root::HS_HousingMountingLocationEblock_2',
		]
	},
	{
		id: 'lightengineA',
		label: {
			de: 'Optik A',
			en: 'Optics A',
			fr: 'Optique A',
		},
		visual: 'housing',
		features: [
			'root::LightEngine_1::LE_ColourTemperature',
			//'root::LightEngine_1::LE_DimmingLevel',
			'root::LightEngine_1::LE_LightDistribution',
			'root::LightEngine_1::LE_LuminousFlux',
			'root::LightEngine_1::LE_LightEngineModuleSize',
			'root::LightEngine_1::LE_OpticalVersion',
			'root::LightEngine_1::LE_ReflectorColour',
		]
	},
	{
		id: 'lightengineB',
		label: {
			de: 'Optik B',
			en: 'Optics B',
			fr: 'Optique B',
		},
		visual: 'housing',
		features: [
			'root::LightEngine_2::LE_ColourTemperature',
			//'root::LightEngine_2::LE_DimmingLevel',
			'root::LightEngine_2::LE_LightDistribution',
			'root::LightEngine_2::LE_LuminousFlux',
			'root::LightEngine_2::LE_LightEngineModuleSize',
			'root::LightEngine_2::LE_OpticalVersion',
			'root::LightEngine_2::LE_ReflectorColour',
		]
	},
	{
		id: 'electricA',
		label: {
			de: 'EBlock A',
			en: 'EBlock A',
			fr: 'EBlock A',
		},
		visual: 'housing',
		features: [
			'root::EBlock_1::EB_ConstantLumenTechnology',
			'root::EBlock_1::EB_Control',
			'root::EBlock_1::EB_EBlockMountingType',
			'root::EBlock_1::EB_ElectricalProtectionClass',
			'root::EBlock_1::EB_Wattage',
			'shared::Zhaga::HS_HousingZhaga'
		]
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];

export const lineSingular = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		features: [
			'shared::Context::CX_Region',
			'shared::Context::CX_Usage',
			'shared::ProductType::HS_HousingType',
		],
		widgets: []
	},
	{
		id: 'lightengine',
		label: {
			de: 'Optik',
			en: 'Optics',
			fr: 'Optique',
		},
		visual: 'optics',
		features: [
			'shared::Context::LU_Filter_LightEmission_Uplight',
			'shared::Context::LU_Filter_LightEmission_CA',
			//'root::LightEngine_1::LE_LightEmission_Uplight',
			//'root::LightEngine_1::LE_LightEmission_CA',
			//'root::LightEngine_2::LE_LightEmission_Uplight',
			//'root::LightEngine_2::LE_LightEmission_CA',

			'root::LightEngine_1::LE_LightDistribution',
			'root::LightEngine_1::LE_ColourTemperature',
			//'root::LightEngine_1::LE_DimmingLevel',
			//'root::LightEngine_1::LE_LuminousFlux',
			'root::LightEngine_1::LE_ReflectorColour',
			'root::LightEngine_1::LE_OpticalVersion',
			'root::LightEngine_1::LE_LightEngineModuleSize',

			//'root::LightEngine_2::LE_ColourTemperature',
			//'root::LightEngine_2::LE_DimmingLevel',
			//'root::LightEngine_2::LE_LightDistribution',
			//'root::LightEngine_2::LE_LuminousFlux',
			//'root::LightEngine_2::LE_LightEngineModuleSize',
			//'root::LightEngine_2::LE_OpticalVersion',
			//'root::LightEngine_2::LE_ReflectorColour',
		],
		widgets: []
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		features: [
			//'shared::PoleBasic::HS_Base',
			'shared::HousingLuminaire::HS_HousingConnection',
			//'shared::PoleBasic::HS_Height',
			'shared::ColourCoating::HS_HousingCoating',
			'shared::ColourCoating::HS_HousingColour',
			//'shared::HousingLuminaire::HS_HousingShape',
			//'shared::HousingLuminaire::HS_HousingHeight',
			//'shared::PoleBasic::HS_NumberPoleDoors',
			'root::HS_HousingMountingLocationEblock_1',
			'root::HS_HousingMountingLocationEblock_2',
			'root::EBlock_1::EB_EBlockMountingType',
			//'shared::HousingLuminaire::HS_HousingPowerConnection'
		],
		widgets: []
	},
	{
		id: 'electricblock',
		label: {
			de: 'Steuerung',
			en: 'Control',
			fr: 'Contrôle',
		},
		visual: 'optics',
		features: [
			'root::EBlock_1::EB_Control',
			'root::EBlock_1::EB_ElectricalProtectionClass',
			'shared::Zhaga::HS_HousingZhaga',
			'root::EBlock_1::EB_ConstantLumenTechnology'
		],
		widgets: []
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];
export const lineSingularIntern = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		features: [
			'shared::Context::CX_Region',
			'shared::Context::CX_Usage',
			'shared::ProductType::HS_HousingType',
			'shared::PoleSpecialLine::HS_Construction',

			'shared::Context::LU_Filter_LightEmission_Uplight',
			'shared::Context::LU_Filter_LightEmission_CA',
			//'root::LightEngine_1::LE_LightEmission_Uplight',
			//'root::LightEngine_1::LE_LightEmission_CA',
			//'root::LightEngine_2::LE_LightEmission_Uplight',
			//'root::LightEngine_2::LE_LightEmission_CA',
		],
		widgets: []
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'model',
		features: [
			//'shared::PoleBasic::HS_Base',
			'shared::PoleBasic::HS_Height',
			'shared::ColourCoating::HS_HousingCoating',
			'shared::ColourCoating::HS_HousingColour',
			//'shared::HousingLuminaire::HS_HousingShape',
			//'shared::HousingLuminaire::HS_HousingHeight',
			'shared::PoleBasic::HS_NumberPoleDoors',
			'shared::HousingLuminaire::HS_HousingConnection',
			'shared::HousingLuminaire::HS_HousingPowerConnection'],
		widgets: []
	},
	{
		id: 'lightengineA',
		label: {
			de: 'Optik A',
			en: 'Optics A',
			fr: 'Optique A',
		},
		visual: 'housing',
		features: [
			'root::LightEngine_1::LE_ColourTemperature',
			//'root::LightEngine_1::LE_DimmingLevel',
			'root::LightEngine_1::LE_LightDistribution',
			'root::LightEngine_1::LE_LuminousFlux',
			'root::LightEngine_1::LE_LightEngineModuleSize',
			'root::LightEngine_1::LE_OpticalVersion',
			'root::LightEngine_1::LE_ReflectorColour',
		],
		widgets: []
	},
	{
		id: 'electricA',
		label: {
			de: 'EBlock A',
			en: 'EBlock A',
			fr: 'EBlock A',
		},
		visual: 'housing',
		features: [
			'root::EBlock_1::EB_ConstantLumenTechnology',
			'root::EBlock_1::EB_Control',
			'root::EBlock_1::EB_EBlockMountingType',
			'root::EBlock_1::EB_ElectricalProtectionClass',
			'root::EBlock_1::EB_Wattage',
			'shared::Zhaga::HS_HousingZhaga'
		],
		widgets: []
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];

